import useSWR from "swr";
import API from "../../../axios/instances/API";

const fetcher = async (url) => {
  const { data } = await API.get(url);
  return data;
};

const useAudienceList = () => {
  const { data, error, mutate } = useSWR("/dashboard/audiences/", fetcher, {
    revalidateOnFocus: false,
  });

  return {
    audienceList: data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};

export default useAudienceList;
